import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ValidationResponse } from '../models/validationResponse';
import { LocalStorageServiceEncrypt } from 'angular-2-local-storage-encrypt';
import { JwtHelperService } from '@auth0/angular-jwt';
import { User } from '../models/user';
import { Brands, ListData } from '../models/ListData';
import { LogInModel } from '../models/logInModel';
import { RegisterModel } from '../models/registerModel';
import { ChangePasswordModel } from '../models/ChangePasswordModel';
import { ResetPassword } from '../models/ResetPassword';

@Injectable({
  providedIn: 'root'
})
export class AccountService extends BaseService {
  // apiUrl = '/api/account';
  apiUrl = '/api/account';

  constructor(private httpClient: HttpClient, private _localStorageService: LocalStorageServiceEncrypt) {
    super();
  }
  isUserLoggedIn(): boolean {
    return !!localStorage.getItem('token');
  }
  signOut() {
    localStorage.clear();
  }
  iSAcceptDisclaimer(): boolean {
    var accept=this._localStorageService.get('AcceptTerms') as boolean;
    return accept;
  }

  getUserInfoFromToken(token: string) {
    const jwtHelper = new JwtHelperService();
    const data = jwtHelper.decodeToken(token) as User;
    // this.user = data;
    // localStorage.mobileNumber=this.user.mobileNumber;
  }
  //================================
  logIn(logIn: LogInModel)
  {
    return this.httpClient.post<any>(
      this.baseUrl +
        this.apiUrl +
        '/Login',logIn,
      this.getAuthHeader()
    );
  }
  //================================
  //================================
  //forgetPassword
  ForgetPassword(mobileNumber: string) {
    return this.httpClient.get<any>(
      this.baseUrl + this.apiUrl + '/ForgetPassword?mobileNumber=' + mobileNumber,
      this.getAuthHeader()
    );
  }
  //================================
  //================================
  ForgetPasswordVerifyOtp(mobileNumber: string, otp: string) {
    return this.httpClient.get<ValidationResponse>(
      this.baseUrl +
        this.apiUrl +
        '/VerifyOtp?mobileNumber=' +
        mobileNumber +
        '&otp=' +
        otp +
        '&IsResetPassword=' +
        true,
      this.getAuthHeader()
    );
  }
  //================================
  //================================
  SetPassword(setPassword: ResetPassword) {
    return this.httpClient.post<any>(
      this.baseUrl +
        this.apiUrl +'/SetPassword',setPassword,
      this.getAuthHeader()
    );
  }
  //================================
  //================================
  checkDisclaimer(userName:string,acceptTerms: boolean)
  {
    return this.httpClient.get<boolean>(
      this.baseUrl +
      '/api/login/CheckDisclaimer?mobileNumber=' +
        userName +
        '&acceptTerms=' +
        acceptTerms,
      this.getAuthHeader()
    );
  }
  //================================
  //================================
  validateMobileNumber(mobileNumber: string) {
    return this.httpClient.get<any>(
      this.baseUrl + this.apiUrl + '/ValidateMobileNumber?mobileNumber=' + mobileNumber,
      this.getAuthHeader()
    );
  }
  //================================
  //================================
  verifyOtp(mobileNumber: string, otp: string) {
    return this.httpClient.get<ValidationResponse>(
      this.baseUrl +
        this.apiUrl +
        '/VerifyOtp?mobileNumber=' +
        mobileNumber +
        '&otp=' +
        otp,
      this.getAuthHeader()
    );
  }
  //================================
  //================================
  createAccount(register: RegisterModel) {
    return this.httpClient.post<ValidationResponse>(
      this.baseUrl +
      this.apiUrl +'/CreateAccount',register,
      this.getAuthHeader()
    );
  }
  //================================
  //================================
  changePassword(changePassword: ChangePasswordModel)
  {
    return this.httpClient.post<ValidationResponse>(
      this.baseUrl +
        this.apiUrl +'/ChangePassword',changePassword,
      this.getAuthHeader()
    );
  }
  //================================
  //================================
  deleteAccount(registerToken) {
    return this.httpClient.delete<ValidationResponse>(
      this.baseUrl + this.apiUrl +'/DeleteAccount?registerToken='+registerToken,
      this.getAuthHeader()
    );
  }
  //================================
  getData(mobileNumber: string, otp: string) {
    return this.httpClient.get<ValidationResponse>(
      this.baseUrl +
        '/api/account' +
        '/VerifyOtp?mobileNumber=' +
        mobileNumber +
        '&otp=' +
        otp,
      this.getAuthHeader()
    );
  }
  GetCitiesList() {
    return this.httpClient.get<ListData[]>(
      this.baseUrl +
        '/api/account/GetCitiesList',
      this.getAuthHeader()
    );
  }


  GetAreasByCityId(id:number) {
    return this.httpClient.get<ListData[]>(
      this.baseUrl +
        '/api/account/GetAreasByCityId?cityId='+id,
      this.getAuthHeader()
    );
  }


  GetBrands() {
    return this.httpClient.get<Brands[]>(
      this.baseUrl +
        '/api/account/GetBrands',
      this.getAuthHeader()
    );
  }
}
